import { useEffect, useState } from 'react'
import { APP_VERSION, fetchBackendVersion } from '@/lib/version'

type Props = {
  className?: string
}

/**
 * Subtle always-visible build version. Title attribute includes backend
 * version when reachable so operators can spot FE/BE drift.
 */
export function AppVersion({ className = '' }: Props) {
  const [backendVersion, setBackendVersion] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    void fetchBackendVersion()
      .then((info) => {
        if (!cancelled) setBackendVersion(info.version)
      })
      .catch(() => {
        if (!cancelled) setBackendVersion(null)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const mismatch = backendVersion != null && backendVersion !== APP_VERSION
  const title = backendVersion
    ? mismatch
      ? `UI ${APP_VERSION} · API ${backendVersion} (mismatch)`
      : `v${APP_VERSION}`
    : `v${APP_VERSION}`

  return (
    <span
      className={`app-version${mismatch ? ' app-version--mismatch' : ''} ${className}`.trim()}
      title={title}
      aria-label={`Application version ${APP_VERSION}`}
    >
      v{APP_VERSION}
    </span>
  )
}
